import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Products from "./components/Products";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import Teams from "./components/Teams";
import Contact from "./components/Contact";
import { Footer } from "./components/Footer";
import styles from "./LandingPage.module.css";

const LandingPage = () => {
  return (
    <div className={styles.container}>
      <div>
        <Header />
        <Hero />
      </div>
      <section id="product"><Products /></section>
      <section id="features"><Features /></section>
      <section id="pricing"><Pricing /></section>
      <section id="team"><Teams /></section>
      <section id="contact"><Contact /></section>
      <Footer />
    </div>
  );
};

export default LandingPage;
